// index.js

import $ from 'jquery';
import { initApp } from './utils/dom.js';
import { loadTreeData } from './utils/api.js';
import { generateHomeCalc, initHomeCalc } from './components/HomeCalc.js'; // <-- НОВЫЙ ИМПОРТ
import { generateFreeCheatForm, initFreeCheatForm, getFreeCheatData } from './components/FreeCheatForm.js';
import { initModal } from './components/Modal.js';

window.application = window.application || {};

$(async function () {
	// Инициализируем базовые DOM-манипуляции и утилиты
	initApp();
	initModal();

	// Загружаем данные по услугам
	Object.assign(application, await loadTreeData());

	if (application.data) {
		// Генерируем и инициализируем новый калькулятор
		generateHomeCalc(application.data);
		initHomeCalc();

		// Генерируем и инициализируем форму бесплатной накрутки
		await generateFreeCheatForm(getFreeCheatData);
		initFreeCheatForm();
	} else {
		console.error("Failed to load application data for calculator.");
	}
});

